import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoPartoEnum } from 'graphql/types.generated'

export interface TipoPartoSelectFieldModel {
  value: TipoPartoEnum
  label: string
}

type TipoPartoSelectFieldProps = CustomSelectFieldProps<TipoPartoSelectFieldModel>

export default function TipoPartoSelectField(props: TipoPartoSelectFieldProps) {
  return (
    <SelectField<TipoPartoSelectFieldModel>
      label='Tipo de parto'
      items={items}
      itemToString={(i) => i?.label}
      {...props}
    />
  )
}

export const items: TipoPartoSelectFieldModel[] = [
  {
    value: TipoPartoEnum.NORMAL,
    label: 'Normal',
  },
  {
    value: TipoPartoEnum.FORCEPS,
    label: 'Fórceps',
  },
  {
    value: TipoPartoEnum.CESAREO,
    label: 'Cesáreo',
  },
]
